export const addSourceToVideo = (element, src) => {
  if (!element || !src) {
    return;
  } else {
    const source = document.createElement("source");
    source.src = src;
    source.type = "video/mp4";
    element.appendChild(source);
  }
};
